module.exports = __webpack_public_path__ + "static/car3-f1c55fa263ef95aed915789838a2791c.png";